
import { defineComponent, getCurrentInstance, onMounted, ref, reactive, computed, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { clearPositionCache } from '@/composables/pages/roster/useRosterPositions'
import apiUseCase from '@/usecase/apiUseCase'
import { ITrayek } from '@/utils/interfaces/iTrayek'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import moment from 'moment'
import { isEmpty, isNull } from 'lodash'
import InputText from 'primevue/inputtext'
import IResponse from '@/utils/interfaces/iResponse'
import PariwisataRosterDialog from '@/views/pages/roster/components/DatePickerPariwisataDialog.vue'
import { PageState } from 'primevue/paginator'
import Paginator from '@/views/components/paginator/Paginator.vue'
// import HeaderFilter from '@/views/pages/plotting-conductor/components/HeaderFilter.vue'
// import LeftFilter from '@/views/pages/plotting-conductor/components/LeftFilter.vue'
import InfoConductor from '@/views/pages/plotting-conductor/components/InfoConductor.vue'
import HjpSideBar from '@/views/components/sidebar/HjpSideBar.vue'
import ChangeStatusForm from '@/views/pages/roster/form/ChangeStatusForm.vue'
import ChangeVehicleForm from '@/views/pages/roster/form/ChangeBusForm.vue'
import ChangeStatusActiveForm from '@/views/pages/roster/form/ChangeStatusActiveForm.vue'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import { plottingUseCase } from '@/usecase'
import { IPlotting } from '@/utils/interfaces/iPlotting'
import { IPreviewRoster } from '@/utils/interfaces/iRoster'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'
import ConfirmModal from '@/views/components/modal/ConfirmModal2.vue'
import { DatePicker } from 'v-calendar'
import { IFilter } from '@/store/modules/plotting/model'
import TableRoster from './components/TableRoster.vue'
import InlineFilter from './components/InlineFilter.vue'
import RosterSummaryCards from './components/RosterSummaryCards.vue'

const module = 'plotting'

export default defineComponent({
  name: 'Roster',
  components: {
    InputText,
    InlineFilter,
    RosterSummaryCards,
    TableRoster,
    Paginator,
    PariwisataRosterDialog,
    HjpSideBar,
    ChangeStatusForm,
    HjpCofirmModal,
    InfoConductor,
    ChangeVehicleForm,
    ChangeStatusActiveForm,
    HjpAlertModal,
    ConfirmModal,
    DatePicker
  },
  setup() {
    const moduleStore = 'hjpTable'
    const moduleRoster = 'roster'
    const app = getCurrentInstance()
    const {
      $icon,
      $toast
    } = app!.appContext.config.globalProperties
    const icon = $icon
    const store = useStore()
    // const endpointPlotting = '/roster/v1/Plotting'
    const endpointTrayek = '/management/v1/Trayek'
    const endpointRoster = '/roster/v1/Roster'
    const endpointRoster2 = '/roster/v2/Rosters'
    const endpointPlotting = '/roster/v1/Plotting'
    const endpointPlotting2 = '/roster/v2/Plottings'
    const endpointTransactionPp2 = '/transaction/v2/TransactionPps'
    const selectedConductor = computed(() => store.getters[`${module}/selectedConductor`])
    const plottingList = ref()
    const selectedTrayek = ref('')
    const placeholder = ref('Cari disini ...')
    const inputSearch = ref('')
    const filterDate = ref<Date>(moment().add(7, 'hours').toDate())
    const trayekList = ref<ITrayek[]>([])
    const dataForm = ref()
    const dataFormEdit = ref()
    const lastUpdate = ref(moment())
    const isEdit = ref(false)
    const isSearch = ref(false)
    const showConfirmResetDialog = ref(false)
    const sidebarFormState = ref(0)
    const currentKondekturRoster = ref([]) as any
    const currentSelectedKondektur = ref(null)
    const refConfirmModal = ref<InstanceType<typeof ConfirmModal>>()
    const modalConfirmation = reactive({
      show: false,
      imgContent: require('@/assets/img/modal-confirmation/roster-confirmation.svg'),
      title: '',
      subTitle: '',
      btnSubmitTitle: 'Simpan',
      subTitleHtml: false,
      isDelete: false
    })
    const headerButton = ref({
      isShow: true,
      label: 'Tambah Pariwisata',
    })
    const showModalForm = computed({
      get: () => store.state[moduleStore].modal.show,
      set: (value) => {
        store.dispatch('setShowModal', value)
      }
    })

    const plottingTableProp = reactive({
      totalRecords: 0,
      isLoading: false,
      pageNumber: 1
    })

    const hideConfirmDialog = () => {
      modalConfirmation.show = false
      isEdit.value = false
    }

    const processGetPlottingDetail = async () => {
      try {
        const dateFilter = moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
        console.log('dateFilter', dateFilter)
        const {
          result,
          error,
          count,
          pagenumber
        } = await apiUseCase.get(`${endpointRoster2}/ByTrayek/${selectedTrayek.value}${returnUrlPrams({
          pageNumber: plottingTableProp.pageNumber,
          filterField: ['regNumber'],
          search: inputSearch.value,
          pageSize: 10,
          custom: [['RosterDate', '=', dateFilter], ['statusRosterCode', '=', 'GBG'], ['statusRosterCode', '=', 'RGL']]
        })}`)
        if (!error) {
          const data = result as IPlotting[]
          plottingList.value = data.map((v: any, index: any) => ({
            ...v,
            index,
            Pp: v.PpOrder,
            DepartureTime: v.DepartureTime
          }))
          plottingTableProp.totalRecords = count
          plottingTableProp.pageNumber = pagenumber
        }
        isEdit.value = false
        isSearch.value = false
        plottingTableProp.isLoading = false
      } catch (error) {
        isEdit.value = false
        isSearch.value = false
        plottingTableProp.isLoading = false
      }
    }

    const getPlottingDetail = async (id: string) => {
      // store.dispatch('showLoading')
      plottingTableProp.isLoading = true
      if (id === selectedTrayek.value && !isEdit.value && !isSearch.value) {
        selectedTrayek.value = ''
        plottingTableProp.isLoading = false
        plottingTableProp.pageNumber = 1
        store.dispatch('hideLoading')
      } else {
        if (id !== selectedTrayek.value && !isEdit.value && !isSearch.value) {
          plottingTableProp.isLoading = false
          plottingTableProp.pageNumber = 1
        }
        selectedTrayek.value = id
        processGetPlottingDetail()
      }
    }

    watch(filterDate, (newVal) => {
      // eslint-disable-next-line no-use-before-define
      getPreviewRoster()
      // eslint-disable-next-line no-use-before-define
      refreshPage()
    })

    const paginate = reactive({
      pageSize: 10,
      pageNumber: 1,
      totalRecords: 0,
    })

    const filtersTrayek = reactive({
      custom: [] as any
    })
    const getAllTrayek = async () => {
      store.dispatch('showLoading')
      filtersTrayek.custom.push(['activeOnly', '=', 'true'], ['trayekTypeId', '=', '8e072a19-599c-45f0-a337-08dbd378cce6'])
      const response = await apiUseCase.get(`${endpointTrayek}${returnUrlPrams({
        pageSize: paginate.pageSize,
        pageNumber: paginate.pageNumber,
        custom: filtersTrayek.custom
      })}`)
      if (!response.error) {
        const result = response.result as ITrayek[]
        trayekList.value = result
        paginate.totalRecords = response.count
      }
      store.dispatch('hideLoading')
    }
    const listFilterTrayek = computed<IFilter[]>(() => store.getters[`${module}/filterTrayek`])
    watch(() => listFilterTrayek.value, (newVal) => {
      const mapResult: string[][] = newVal.map((v: IFilter) => ['name', '=', v.label])
      const findFilter: string[] = filtersTrayek.custom.filter((v: string[]) => v[0] !== 'name')
      filtersTrayek.custom = [...findFilter, ...mapResult]
      getAllTrayek()
    }, { deep: true })

    const listFilterClass = computed<IFilter[]>({
      get: () => store.getters[`${module}/filterClass`],
      set: (val) => {
        console.log('val changers', val)
      }
    })
    watch(() => listFilterClass.value, (newVal) => {
      const mapResult: string[][] = newVal.map((v: IFilter) => ['classId', '=', v.value])
      const findFilter: string[] = filtersTrayek.custom.filter((v: string[]) => v[0] !== 'classId')
      filtersTrayek.custom = [...findFilter, ...mapResult]
      getAllTrayek()
    }, { deep: true })
    const listFilterTol = computed<IFilter[]>(() => store.getters[`${module}/filterTol`])
    watch(() => listFilterTol.value, (newVal) => {
      const mapResult: string[][] = newVal.map((v: IFilter) => ['isTol', '=', v.value])
      const findFilter: string[] = filtersTrayek.custom.filter((v: string[]) => v[0] !== 'isTol')
      filtersTrayek.custom = [...findFilter, ...mapResult]
      getAllTrayek()
    }, { deep: true })

    const getDetailRosterPariwisata = async () => {
      store.dispatch('showLoading')
      console.log('isEdit', isEdit.value)
      plottingTableProp.isLoading = true
      if (selectedTrayek.value === 'pariwisata' && !isEdit.value && !isSearch.value) {
        console.log('pariwisata')
        selectedTrayek.value = ''
        plottingTableProp.isLoading = false
        plottingTableProp.pageNumber = 1
        store.dispatch('hideLoading')
      } else {
        try {
          selectedTrayek.value = 'pariwisata'
          // selectedTrayek.value = id
          const dateFilter = moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
          console.log('dateFilter', dateFilter)
          const {
            result,
            error,
            count,
            pagenumber
          } = await apiUseCase.get(`${endpointRoster}${returnUrlPrams({
            pageNumber: plottingTableProp.pageNumber,
            filterField: ['regNumber'],
            search: inputSearch.value,
            pageSize: 10,
            custom: [['startDate', '=', dateFilter], ['endDate', '=', dateFilter], ['statusRosterCode', '=', 'PRW']]
          })}`)
          if (!error) {
            const data = result as IPlotting[]
            plottingList.value = data.map((v) => ({
              ...v,
              Pp: v.PpOrder,
              DepartureTime: v.DepartureTime
            }))
            plottingTableProp.totalRecords = count
            plottingTableProp.pageNumber = pagenumber
          }
          console.log('error pariwisata1')
          plottingTableProp.isLoading = false
          store.dispatch('hideLoading')
          isEdit.value = false
          isSearch.value = false
        } catch (error) {
          console.log('error pariwisata2')
          plottingTableProp.isLoading = false
          store.dispatch('hideLoading')
          isEdit.value = false
          isSearch.value = false
        }
      }
    }

    const progressSubmitRoster = async () => {
      console.log('xxxx', dataFormEdit.value)
      store.dispatch('showLoading')
      const payload = {
        RosterDate: dataFormEdit.value.RosterDate,
        DepartureTime: dataFormEdit.value.DepartureTime,
        ArrivalTime: dataFormEdit.value.ArrivalTime,
        CondecturId: dataFormEdit.value.CondecturId,
        CondecturUsername: dataFormEdit.value.CondecturUsername,
        CondecturName: dataFormEdit.value.CondecturName,
        MsVehicleId: dataFormEdit.value.MsVehicleId,
        RegNumber: dataFormEdit.value.RegNumber,
        SeatCapacity: dataFormEdit.value.SeatCapacity,
        TrayekId: dataFormEdit.value.TrayekId,
        TrayekName: dataFormEdit.value.TrayekName,
        TrayekCode: dataFormEdit.value.TrayekCode,
        TrayekTypeId: dataFormEdit.value.TrayekTypeId,
        TrayekTypeCode: dataFormEdit.value.TrayekTypeCode,
        TrayekTypeName: dataFormEdit.value.TrayekTypeName,
        TrayekSubId: dataFormEdit.value.TrayekSubId,
        TrayekClassName: dataFormEdit.value.TrayekClassName,
        StatusRemark: dataFormEdit.value.StatusRemark,
        IsTol: dataFormEdit.value.IsTol,
        PpOrder: dataFormEdit.value.PpOrder,
        IsPublished: dataFormEdit.value.IsPublished,
        DriverId: dataFormEdit.value.DriverId,
        DriverName: dataFormEdit.value.DriverName,
        HelperId: dataFormEdit.value.HelperId,
        HelperName: dataFormEdit.value.HelperName,
        MsStatusRosterId: dataFormEdit.value.MsStatusRosterId
      }
      try {
        const response = await apiUseCase.postOrPut(`${endpointRoster2}`, dataFormEdit.value.Id, payload)
        console.log('resp', response)
        if (!response.error) {
          $toast.add({
            severity: 'success',
            detail: 'Roster berhasil disimpan.',
            group: 'bc',
            closable: false,
            life: 3000
          })
        } else {
          $toast.add({
            severity: 'error',
            detail: response.message || 'Roster gagal disimpan. Silahkan coba beberapa saat lagi.',
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
        if (selectedTrayek.value === 'pariwisata') {
          console.log('error pariwisata4')
          getDetailRosterPariwisata()
        } else {
          getPlottingDetail(selectedTrayek.value)
        }
        hideConfirmDialog()
        store.dispatch('hideLoading')
      } catch (error) {
        console.log('error pariwisata3')
        if (selectedTrayek.value === 'pariwisata') {
          getDetailRosterPariwisata()
        } else {
          getPlottingDetail(selectedTrayek.value)
        }
        hideConfirmDialog()
        // isEdit.value = false
        store.dispatch('hideLoading')
      }
    }

    // const progressSubmitPlotting = async () => {
    //   store.dispatch('showLoading')
    //   try {
    //     const {
    //       error,
    //       message
    //     } = await plottingUseCase.editPlotting(dataForm.value)
    //     if (!error) {
    //       $toast.add({
    //         severity: 'success',
    //         detail: message,
    //         group: 'bc',
    //         closable: false,
    //         life: 3000
    //       })
    //       getPlottingDetail(selectedTrayek.value)
    //       // checkEmptyTrayekSubs()
    //     } else {
    //       $toast.add({
    //         severity: 'error',
    //         detail: message,
    //         group: 'bc',
    //         closable: false,
    //         life: 3000
    //       })
    //     }
    //     store.dispatch('hideLoading')
    //   } catch (error) {
    //     getPlottingDetail(selectedTrayek.value)
    //     store.dispatch('hideLoading')
    //   }
    // }

    const mappingCurrentCondecturRoster = (data: any) => {
      let temp: any = null
      let currIndex: any = -1
      currentKondekturRoster.value = []
      for (let index = 0; index < data.length; index++) {
        if (data[index].RegNumber !== temp) {
          temp = data[index].RegNumber
          currIndex += 1
          const obj = {
            nopol: data[index].RegNumber,
            pps: [] as any
          }
          obj.pps.push({ order: data[index].PpOrder, time: data[index].DepartureTime.slice(0, 5) })
          currentKondekturRoster.value[currIndex] = obj
        } else {
          currentKondekturRoster.value[currIndex].pps.push({ order: data[index].PpOrder, time: data[index].DepartureTime.slice(0, 5) })
        }
      }
    }

    const onSubmitRoster = async (val: any) => {
      console.log('val', val)
      isEdit.value = true
      const dateFilter = moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
      console.log('submit', val)
      val.RosterDate = dateFilter
      dataFormEdit.value = val
      try {
        const { error, message, result } = await apiUseCase.get(`${endpointRoster}/Condectur/${val.CondecturId}${returnUrlPrams({
          custom: [['rosterDate', '=', dateFilter]]
        })}`)
        if (!error) {
          if (result.CondecturRosterCount > 0) {
            mappingCurrentCondecturRoster(result.CondecturRosters)
            modalConfirmation.title = `Kondektur ${result.CondecturName} Sudah Mempunyai Jadwal`
            modalConfirmation.subTitle = 'Kondektur sudah mempunyai jadwal, mohon cek jadwal kondektur berikut ini : '
            modalConfirmation.btnSubmitTitle = 'Tetap Simpan Roster'
            modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/dirty-edit-plotting.svg')
          } else {
            modalConfirmation.title = 'Apakah Anda Yakin Ingin Menyimpan Roster?'
            modalConfirmation.subTitle = 'Pastikan data yang Anda masukkan  sudah benar sebelum tersimpan'
            modalConfirmation.btnSubmitTitle = 'Simpan'
            modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/clean-edit-plotting.svg')
          }
          modalConfirmation.show = true
        } else {
          $toast.add({
            severity: 'error',
            detail: message,
            group: 'bc',
            closable: false,
            life: 3000
          })
          if (selectedTrayek.value === 'pariwisata') {
            getDetailRosterPariwisata()
          } else {
            getPlottingDetail(selectedTrayek.value)
          }
        }
        store.dispatch('hideLoading')
      } catch (error) {
        if (selectedTrayek.value === 'pariwisata') {
          getDetailRosterPariwisata()
        } else {
          getPlottingDetail(selectedTrayek.value)
        }
        store.dispatch('hideLoading')
      }
    }

    // const onSubmitPlotting = async (val: any) => {
    //   console.log('val', val)
    //   const dateFilter = moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
    //   val.PlottingDate = dateFilter
    //   dataForm.value = val
    //   try {
    //     const response = await apiUseCase.get(`${endpointPlotting}/Condectur/${val.CondecturId}${returnUrlPrams({
    //       custom: [['plottingDate', '=', dateFilter]]
    //     })}`)
    //     console.log('response', response)
    //     if (!response.error) {
    //       let optionConfirm = {
    //         title: 'Apakah Anda Yakin Ingin Menyimpan Plotting?',
    //         subTitle: 'Pastikan data yang Anda masukkan  sudah benar sebelum tersimpan',
    //         btnSubmitTitle: 'Simpan',
    //         imgContent: require('@/assets/img/modal-confirmation/clean-edit-plotting.svg')
    //       }
    //       if (response.result.CondecturPlottingCount > 0) {
    //         optionConfirm = {
    //           ...optionConfirm,
    //           title: 'Apakah Anda Yakin Ingin Mengubah Plotting?',
    //           imgContent: require('@/assets/img/modal-confirmation/dirty-edit-plotting.svg')
    //         }
    //       }
    //       // eslint-disable-next-line no-unused-expressions
    //       refConfirmModal.value?.openModal(optionConfirm)
    //         .then((isConfirm) => {
    //           if (isConfirm) {
    //             progressSubmitPlotting()
    //           }
    //         })
    //     } else {
    //       $toast.add({
    //         severity: 'error',
    //         detail: response.message,
    //         group: 'bc',
    //         closable: false,
    //         life: 3000
    //       })
    //       getPlottingDetail(selectedTrayek.value)
    //     }
    //     store.dispatch('hideLoading')
    //   } catch (error) {
    //     getPlottingDetail(selectedTrayek.value)
    //     store.dispatch('hideLoading')
    //   }
    // }

    const onSearch = () => {
      // console.log('valSearch', val)
      isSearch.value = true
      plottingTableProp.pageNumber = 1
      if (selectedTrayek.value === 'pariwisata') {
        getDetailRosterPariwisata()
      } else {
        getPlottingDetail(selectedTrayek.value)
      }
    }

    const onChangePage = ({ page }: any) => {
      paginate.pageNumber = page + 1
      getAllTrayek()
    }

    const onChangeStatusRosterAction = () => {
      console.log('onChangeStatusRosterAction', store.state)
      sidebarFormState.value = 0
      showModalForm.value = true
    }

    const onChangeVehicleRosterAction = () => {
      console.log('onChangeStatusRosterAction', store.state)
      sidebarFormState.value = 1
      showModalForm.value = true
    }

    const onChangeStatusActiveRosterAction = () => {
      sidebarFormState.value = 2
      showModalForm.value = true
    }

    const hideModalForm = () => {
      showModalForm.value = false
    }

    const showConfirmDialog = (data: any, isChangeStatus: any) => {
      console.log('data', data)
      isEdit.value = false
      dataForm.value = null
      dataForm.value = data
      if (isChangeStatus) {
        modalConfirmation.isDelete = false
        modalConfirmation.subTitleHtml = true
        modalConfirmation.title = 'Ganti Status?'
        modalConfirmation.subTitle = `<div class="text-grey">Apakah Anda yakin akan mengganti status <span class="font-bold" style="color: red; text-decoration: line-through;">${store.state.hjpTable.modal.data.RosterStatusName}</span> pada bus <span style="color: black;">${store.state.hjpTable.modal.data.RegNumber}, PP${store.state.hjpTable.modal.data.Pp} (${store.state.hjpTable.modal.data.DepartureTime.slice(0, 5)})</span> menjadi <span class="font-bold text-primary">${dataForm.value.Status.Name ?? store.state.hjpTable.modal.data.MsStatusRoster?.Name}</span>?</div>`
        modalConfirmation.btnSubmitTitle = 'Ganti Status'
      } else {
        modalConfirmation.imgContent = require('@/assets/img/modal-confirmation/vehicle-add-update.svg')
        modalConfirmation.isDelete = true
        modalConfirmation.subTitleHtml = true
        modalConfirmation.title = dataForm.value.IsActive ? 'Non Aktifkan Bus ?' : 'Aktifkan Bus ?'
        modalConfirmation.subTitle = dataForm.value.IsActive
          ? `<div class="text-grey">Bus <span class="font-bold">${data.RegNumber}</span> akan di non aktifkan. Bus tidak akan dapat diberi jadwal hingga diaktifkan kembali</div>`
          : `<div class="text-grey">Bus <span class="font-bold">${data.RegNumber}</span> akan diaktifkan kembali.</div>`
        modalConfirmation.btnSubmitTitle = dataForm.value.IsActive ? 'Nonaktifkan Bus' : 'Aktifkan Bus'
      }
      modalConfirmation.show = true
    }

    const onDeactiveRosterAction = (data?: any) => {
      console.log('onDeactiveRosterAction', store.state)
      if (!store.state.hjpTable.modal.data.IsActive) {
        showConfirmDialog(store.state.hjpTable.modal.data, false)
      } else {
        const obj = {
          ...store.state.hjpTable.modal.data,
          Description: data.Description
        }
        showConfirmDialog(obj, false)
      }
    }

    const submitFromDialog = () => {
      console.log('dataForm', dataForm.value)
      if (modalConfirmation.isDelete) {
        const payload = {
          isActived: !dataForm.value.IsActive,
          statusRemark: dataForm.value.Description ?? null
        }
        store.dispatch('showLoading')
        apiUseCase.patch(`${endpointRoster}`, dataForm.value.Id, payload).then((res: IResponse) => {
          console.log('res', res)
          if (!res.error) {
            $toast.add({
              severity: 'success',
              detail: res.message,
              group: 'bc',
              closable: false,
              life: 3000
            })
            showModalForm.value = false
            selectedTrayek.value = ''
          } else {
            $toast.add({
              severity: 'error',
              detail: res.message,
              group: 'bc',
              closable: false,
              life: 3000
            })
            showModalForm.value = false
            selectedTrayek.value = ''
          }
        }).catch((err: any) => {
          console.log('err delete', err)
        })
      } else {
        const payload = {
          msStatusRosterId: dataForm.value.Status.Id ?? store.state.hjpTable.modal.data.MsStatusRoster?.Id,
          statusRemark: dataForm.value.Description
        }

        store.dispatch('showLoading')
        apiUseCase.patch(`${endpointRoster}/ChangeStatus`, store.state.hjpTable.modal.data.Id, payload).then((res: IResponse) => {
          if (!res.error) {
            $toast.add({
              severity: 'success',
              detail: res.message,
              group: 'bc',
              closable: false,
              life: 3000
            })
            showModalForm.value = false
            selectedTrayek.value = ''
          } else {
            $toast.add({
              severity: 'error',
              detail: res.message,
              group: 'bc',
              closable: false,
              life: 3000
            })
            showModalForm.value = false
            selectedTrayek.value = ''
          }
        }).catch((err: any) => {
          console.log('err delete', err)
        })
      }
      hideConfirmDialog()
      store.dispatch('hideLoading')
    }

    const rosterPreview = ref<IPreviewRoster>()

    const getPreviewRoster = async () => {
      store.dispatch('showLoading')
      try {
        const dateFilter = moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
        const {
          result,
          error
        } = await apiUseCase.get(`${endpointRoster}/PreviewRoster${returnUrlPrams({
          custom: [['rosterDate', '=', dateFilter]]
        })}`)
        if (!error) {
          const resultMap = result as IPreviewRoster
          rosterPreview.value = resultMap
        }
        store.dispatch('hideLoading')
      } catch (error) {
        store.dispatch('hideLoading')
      }
    }

    const refreshPage = () => {
      clearPositionCache()
      showModalForm.value = false
      selectedTrayek.value = ''
      lastUpdate.value = moment()
      getAllTrayek()
    }

    watch(store.getters[`${moduleRoster}/isReload`], (newVal) => {
      // eslint-disable-next-line no-use-before-define
      getPreviewRoster()
      // eslint-disable-next-line no-use-before-define
      refreshPage()
    })

    watch(store.getters[`${moduleRoster}/isReloadDetail`], (newVal) => {
      if (selectedTrayek.value === 'pariwisata') {
        getDetailRosterPariwisata()
      } else {
        getPlottingDetail(selectedTrayek.value)
      }
    })

    const generateRosterAction = () => {
      console.log('date', moment(filterDate.value.toDateString()).format('YYYY-MM-DD'))
      console.log('dateX', filterDate.value)
      // console.log('asdsad')
      store.dispatch('showLoading')
      const payload = {
        RosterDate: moment(filterDate.value.toDateString()).format('YYYY-MM-DD')
      }
      apiUseCase.postWithNoId(`${endpointRoster}/GenerateRoster`, payload).then((res: IResponse) => {
        if (!res.error) {
          $toast.add({
            severity: 'success',
            detail: res.message,
            group: 'bc',
            closable: false,
            life: 3000
          })
          showModalForm.value = false
          selectedTrayek.value = ''
          refreshPage()
        } else {
          $toast.add({
            severity: 'error',
            detail: res.message,
            group: 'bc',
            closable: false,
            life: 3000
          })
        }
      }).catch((err: any) => {
        console.log('err delete', err)
      })
      store.dispatch('hideLoading')
    }

    const nextPagePlotting = (evt: PageState) => {
      // console.log('parent page', evt)
      plottingTableProp.pageNumber = evt.page + 1
      isSearch.value = true
      if (selectedTrayek.value === 'pariwisata') {
        getDetailRosterPariwisata()
      } else {
        getPlottingDetail(selectedTrayek.value)
      }
    }

    const reloadFromVehicle = () => {
      processGetPlottingDetail()
    }

    const cannotResetModalattr = reactive({
      show: false,
      imgContent: require('@/assets/img/modal-confirmation/cannot-reset-roster.png'),
      title: 'Bus Sudah Punya Transaksi!',
      subTitle: 'Reset gagal dilakukan karena bus sudah diberangkatkan oleh Kondektur dan memiliki transaksi yang sedang berjalan.',
      btnSubmitTitle: 'Kembali',
      subTitleHtml: false,
      isDelete: false
    })

    const modalConfirmResetRoster = reactive({
      show: false,
      imgContent: require('@/assets/img/modal-confirmation/reset-roster-confirmation.png'),
      title: 'Reset Keberangkatan?',
      subTitle: 'Reset keberangkatan akan menghapus data transaksi saat ini dan membuat ulang data transaksi yang baru.',
      btnSubmitTitle: 'Lanjut Reset',
      subTitleHtml: false,
      isDelete: false
    })

    const hideCannotResetRosterModal = () => {
      cannotResetModalattr.show = false
    }

    const showCannotResetRosterModal = () => {
      cannotResetModalattr.show = true
    }

    const processResetRosterAct = async () => {
      console.log('reset', store.state)
      store.dispatch('showLoading')
      const selectedRoster = store.state.hjpTable?.modal?.data
      await apiUseCase.put(`${endpointTransactionPp2}/by-roster/${selectedRoster.Id}/reset`, null).then((response) => {
        const { result, error } = response
        if (!error) {
          $toast.add({
            severity: 'success',
            summary: 'Reset Keberangkatan Berhasil!',
            detail: 'Reset PP berhasil dilakukan. Silakan berangkatkan kembali PP tersebut!',
            group: 'bc',
            closable: false,
            life: 3000
          })
          processGetPlottingDetail()
          // eslint-disable-next-line no-use-before-define
          hideResetRosterModal()
        } else {
          // eslint-disable-next-line no-use-before-define
          hideResetRosterModal()
          showCannotResetRosterModal()
        }
        store.dispatch('storeRowDataTable', null)
      })
      store.dispatch('hideLoading')
    }

    const onResetRosterAct = () => {
      console.log('xxx')
      // eslint-disable-next-line no-use-before-define
      showConfirmResetDialogAct()
    }

    const submitFromResetModal = () => {
      console.log('submitResetX')
      processResetRosterAct()
    }

    const showConfirmResetDialogAct = () => {
      modalConfirmResetRoster.show = true
      showConfirmResetDialog.value = true
    }

    const hideResetRosterModal = () => {
      modalConfirmResetRoster.show = false
      showConfirmResetDialog.value = false
      store.dispatch('storeRowDataTable', null)
    }

    onMounted(() => {
      store.dispatch('setHeaderButton', headerButton.value)
      getPreviewRoster()
      getAllTrayek()
    })

    const prevDate = () => {
      filterDate.value = moment(filterDate.value as any).subtract(1, 'days').toDate()
    }

    const nextDate = () => {
      filterDate.value = moment(filterDate.value as any).add(1, 'days').toDate()
    }

    onBeforeUnmount(() => {
      store.dispatch(`${module}/flushPlottingFilters`)
    })

    return {
      getPlottingDetail,
      plottingList,
      moment,
      selectedTrayek,
      placeholder,
      inputSearch,
      icon,
      onSearch,
      store,
      filterDate,
      prevDate,
      nextDate,
      trayekList,
      listFilterTrayek,
      listFilterClass,
      module,
      // onSubmitPlotting,
      paginate,
      onChangePage,
      selectedConductor,
      isEmpty,
      getDetailRosterPariwisata,
      onDeactiveRosterAction,
      showModalForm,
      onChangeStatusRosterAction,
      hideModalForm,
      modalConfirmation,
      hideConfirmDialog,
      showConfirmDialog,
      submitFromDialog,
      refreshPage,
      lastUpdate,
      generateRosterAction,
      plottingTableProp,
      nextPagePlotting,
      isEdit,
      // progressSubmitPlotting,
      sidebarFormState,
      onChangeVehicleRosterAction,
      reloadFromVehicle,
      rosterPreview,
      onChangeStatusActiveRosterAction,
      currentKondekturRoster,
      listFilterTol,
      cannotResetModalattr,
      hideCannotResetRosterModal,
      onResetRosterAct,
      modalConfirmResetRoster,
      showConfirmResetDialog,
      submitFromResetModal,
      hideResetRosterModal,
      refConfirmModal,
      onSubmitRoster,
      progressSubmitRoster
    }
  }
})
